import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const usersApiService = async () =>
  new JsonApiService("users", {
    baseUrl: `${visionURL}/admin_console/api`,
    credentials: "include"
  });

export const useUsers = () => {
  return {
    getUsers: async ({ page, sort, filters, include = [], fields = {} }) => {
      const service = await usersApiService();
      const response = await service
        .page(page)
        .sort(sort)
        .where(filters)
        .include(include)
        .fields(fields)
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },
    getUser: async (id, { include = [], fields = {} }) => {
      const service = await usersApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .find(id)
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    }
  };
};
